import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7b534447")

_pushScopeId("data-v-7b534447")
const _hoisted_1 = /*#__PURE__*/_createVNode("p", { class: "text-12px xxl:text-14px font-montserrat font-semibold" }, " Pilih Virtual Account ", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px text-red-lp-300 mt-2" }, " Virtual Account lama sudah tidak berlaku. Mohon gunakan Virtual Account terbaru yang tertera pada halaman ini. ", -1)
const _hoisted_3 = { class: "mt-10" }
const _hoisted_4 = /*#__PURE__*/_createVNode("p", { class: "mt-8 text-12px xxl:text-14px font-normal" }, " Nomor Virtual Account ", -1)
const _hoisted_5 = { class: "flex flex-row justify-between" }
const _hoisted_6 = { class: "text-20px font-semibold" }
const _hoisted_7 = {
  key: 0,
  class: "text-16px font-montserrat font-semibold mt-5"
}
const _hoisted_8 = { class: "mt-5 ml-6 text-12px xxl:text-14px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_BannerCashback = _resolveComponent("BannerCashback")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _directive_sanitize_html = _resolveDirective("sanitize-html")!

  return (_openBlock(), _createBlock("div", {
    class: `tab-height px-8 py-4 overflow-auto ${_ctx.isAnyCashbackConfigActive ? 'pb-48' : 'pb-32'} text-black-lp-300`
  }, [
    _createVNode(_component_BannerCashback),
    _hoisted_1,
    _createVNode(_component_CustomDropdown, {
      class: "w-1/2 mt-2",
      options: _ctx.banks,
      onSelect: _ctx.onSelectMethodBank,
      selectedItem: _ctx.selectedBankVirtualAccount,
      customChevronStyle: `w-6`,
      isCustomWidth: ""
    }, null, 8, ["options", "onSelect", "selectedItem"]),
    _hoisted_2,
    (_ctx.detailSelectedBankVirtualAccount)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          _createVNode("div", _hoisted_3, [
            _createVNode("img", {
              src: _ctx.detailSelectedBankVirtualAccount.bankLogo,
              width: "110.6",
              alt: "bank_logo"
            }, null, 8, ["src"]),
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode("p", _hoisted_6, _toDisplayString(_ctx.detailSelectedBankVirtualAccount.accountNumber), 1),
              _createVNode("p", {
                class: "text-12px xxl:text-14px text-red-lp-500 font-medium cursor-pointer hover:underline",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (
              _ctx.copyVirtualAccount(_ctx.detailSelectedBankVirtualAccount.accountNumber)
            ))
              }, " Salin ")
            ])
          ]),
          (_ctx.detailSelectedBankVirtualAccount.paymentProcedure)
            ? (_openBlock(), _createBlock("p", _hoisted_7, " Cara Top Up "))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_8, [
            _withDirectives(_createVNode("div", null, null, 512), [
              [_directive_sanitize_html, _ctx.detailSelectedBankVirtualAccount.paymentProcedure]
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
})